import { module } from 'angular';

import { default as scriptingViewName, ScriptingView } from './scripting-view.component.ajs';

export default module('contact.agent.helpzone.scripting-view', []).component(scriptingViewName, new ScriptingView()).name;
